/** Max sync events NotificationContext keeps in each buffer. */
export const SYNC_EVENT_BUFFER_SIZE = 50;

/** Anything held in a seq-stamped sync buffer (transaction.sync, waitlist.sync). */
interface Sequenced {
  seq: number;
}

/** Highest seq currently in the buffer (0 when empty). */
export function latestSyncSeq(events: readonly Sequenced[]): number {
  return events.length > 0 ? events[events.length - 1].seq : 0;
}

/**
 * Events with seq > lastSeenSeq, plus the cursor to remember afterwards.
 * Seq-based (not length-based) so it keeps delivering after the bounded
 * buffer starts dropping old entries.
 */
export function takeNewSyncEvents<T extends Sequenced>(
  events: readonly T[],
  lastSeenSeq: number,
): { newEvents: T[]; lastSeenSeq: number } {
  const newEvents = events.filter((ev) => ev.seq > lastSeenSeq);
  return {
    newEvents,
    lastSeenSeq:
      newEvents.length > 0 ? newEvents[newEvents.length - 1].seq : lastSeenSeq,
  };
}
